/**
 * One WebCodecs frame drawn on the guest canvas, in the two clocks the calibrated latency
 * probe correlates: the host sender's clock for the frame (`sentUs`, carried on every
 * fragment) and the guest's wall clock at the draw. The host turns `sentUs` into its own
 * wall time through the sender's clock anchor and reports the difference exactly as it
 * does for an Electron frame.
 */
export type WebCodecsPaintSample = {
  sentUs: number;
  paintWallMs: number;
};

/**
 * Maps a worker-clock draw time onto the guest wall clock. The worker and window
 * `performance` clocks share an origin, so the age of the draw on the window clock is the
 * age on the wall clock.
 */
export function paintSampleFrom(
  event: { sentUs?: number; paintedAtUs?: number },
  nowUs: number,
  nowWallMs: number,
): WebCodecsPaintSample | undefined {
  if (event.sentUs === undefined || event.paintedAtUs === undefined) return undefined;
  if (!Number.isFinite(event.sentUs) || !Number.isFinite(event.paintedAtUs) || event.sentUs < 0) return undefined;
  const ageMs = Math.max(0, nowUs - event.paintedAtUs) / 1000;
  return { sentUs: event.sentUs, paintWallMs: nowWallMs - ageMs };
}
